<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="$parent.textPageTitle">
            <div class="title">{{$parent.textPageTitle}}</div>
            <div class="desc" v-html="$parent.textPageHeader"></div>
            <div class="desc" v-html="$parent.textPageContent"></div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'TextPage',
  props: ['slug'],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  mounted() {
    const identifier = this.slug || this.$route.params.id || this.$route.params.slug;
    this.$parent.getTextPageContent(identifier);
  },
  watch: {
    slug() {
      const identifier = this.slug || this.$route.params.id || this.$route.params.slug;
      this.$parent.getTextPageContent(identifier);
    },
    '$route.params.id'() {
      const identifier = this.slug || this.$route.params.id || this.$route.params.slug;
      this.$parent.getTextPageContent(identifier);
    },
    '$route.params.slug'() {
      const identifier = this.slug || this.$route.params.id || this.$route.params.slug;
      this.$parent.getTextPageContent(identifier);
    }
  },
  methods: {
    
  }
}
</script>